<template>
    <default-field :errors="errors" :title="title">
        <template v-slot:field="slotProps">
            <div class="input-group">
                <flat-pickr
                    :config="config"
                    :class="[slotProps.hasErrors ? invalidClass : '', className]"
                    v-bind="$attrs"
                    v-on:input="setValue"
                />

                <div class="input-group-append" v-if="wrap">
                    <button class="btn btn-default" type="button" title="Toggle" data-toggle>
                        <i class="fa fa-calendar">
                            <span aria-hidden="true" class="sr-only">Toggle</span>
                        </i>
                    </button>
                    <button class="btn btn-default" type="button" title="Clear" data-clear>
                        <i class="fa fa-times">
                            <span aria-hidden="true" class="sr-only">Clear</span>
                        </i>
                    </button>
                </div>
            </div>
        </template>
    </default-field>
</template>

<script>
import DefaultField from "./DefaultField";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
// import {Hindi} from 'flatpickr/dist/l10n/hi.js';

export default {
    components: {
        DefaultField,
        flatPickr
    },

    inheritAttrs: false,

    data() {
        return {
            config: {
                wrap: this.wrap,
                altFormat: this.displayFormat,
                altInput: true,
                dateFormat: this.format,
                enableTime: this.time,
                time_24hr: this.time24hr,
                noCalendar: !this.calendar,
                // locale: Hindi,
                mode: this.mode
            }
        };
    },

    props: {
        className: {
            type: String,
            default:
                "shadow-sm appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-gray-600"
        },
        invalidClass: {
            type: String,
            default: "is-invalid"
        },
        errors: {
            type: Array,
            default: () => []
        },
        format: {
            type: String,
            default: "Y-m-d"
        },
        displayFormat: {
            type: String,
            default: "d.m.Y"
        },
        wrap: {
            type: Boolean,
            default: false
        },
        time: {
            type: Boolean,
            default: false
        },
        calendar: {
            type: Boolean,
            default: true
        },
        time24hr: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: null
        },
        mode: {
            type: String,
            default: "single"
        }
    },

    methods: {
        setValue(value) {
            this.$emit("input", value);
            console.log("set value", value);
        }
    }
};
</script>